import * as React from 'react';
import { InformationalTooltip } from 'components/InformationalTooltip';
import { Divider } from '@mui/material';

interface Props {
  title: React.ReactNode;
  tooltip?: React.ReactNode;
  value?: React.ReactNode;
}

export const SectionTitle: React.FC<Props> = (props) => {
  const { title, tooltip, value } = props;
  return (
    <div className="flex flex-col space-y-3">
      <div className="flex space-x-2 items-center">
        <h3 className="font-medium">
          {value && <span className="text-red-900 font-bold">{value}</span>} {title}
        </h3>
        {tooltip && <InformationalTooltip>{tooltip}</InformationalTooltip>}
      </div>
      <Divider />
    </div>
  );
};
SectionTitle.displayName = 'Shipments.Dashboard.SectionTitle';
